var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberWideFlange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconMemberWideFlange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberWideFlange"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.1 36.56 32.06 36.56 32.06 34.94 25.9 34.94 25.21 34.76 24.7 34.25 24.52 33.56 24.52 14.44 24.7 13.75 25.21 13.24 25.9 13.06 32.06 13.06 32.06 11.44 15.94 11.44 15.94 13.06 22.1 13.06 22.79 13.24 23.3 13.75 23.48 14.5 23.48 33.56 23.3 34.25 22.79 34.76 22.1 34.94 15.94 34.94 15.94 36.56 22.1 36.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberWideFlange);
export default __webpack_public_path__ + "static/media/IconMemberWideFlange.4536690c40939c8ed8cc78c6b81fbd15.svg";
export { ForwardRef as ReactComponent };